var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{ 'uk-text-right': _vm.rightAlign }},[_c('label',{class:{ underline: _vm.underline }},[_vm._v(" "+_vm._s(_vm.label)+" ")])]),_c('p',{staticClass:"uk-margin-remove-top uk-margin-small-bottom",class:{ 'uk-text-right': _vm.rightAlign, multiline: _vm.multiline }},[_vm._v(" "+_vm._s(_vm.displayValue)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }